import { render, staticRenderFns } from "./CustomValueDisplay.vue?vue&type=template&id=4d0e133c&"
import script from "./CustomValueDisplay.vue?vue&type=script&lang=ts&"
export * from "./CustomValueDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports